// AMB-717 — client links in the app. A link connects an Agents client to that client's real
// Launch OS account, so the whole agency can work in it (Sites, Funnels, Claude) without the
// client's password. Server rules live in the API (/v1/clientLinks).
import { API_DOMAIN } from "@launchos/shared-utils/env";

import type { ClientLink } from "./clientLinkMatch";
export { linkForClient, linkedLabel } from "./clientLinkMatch";
export type { ClientLink } from "./clientLinkMatch";

const call = async (token: string, path: string, init: RequestInit = {}) => {
  const res = await fetch(`${API_DOMAIN}/clientLinks${path}`, {
    ...init,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, ...(init.headers || {}) },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok || body.error) throw new Error(body.error || "Something went wrong. Try again.");
  return body;
};

export const listClientLinks = (token: string): Promise<ClientLink[]> => call(token, "");

export const linkClientAccount = (
  token: string,
  data: { email: string; password: string; clientName: string; clientSlug?: string },
): Promise<{ result: "linked" | "already-linked"; link: ClientLink }> =>
  call(token, "", { method: "POST", body: JSON.stringify(data) });

export const unlinkClientAccount = (token: string, id: string) => call(token, `/${id}`, { method: "DELETE" });
